// extracted by mini-css-extract-plugin
export default {"crossStyle":"Qr_crossStyle__CXFzl","bodyModal":"Qr_bodyModal__uuqq1","subText":"Qr_subText__jQl6k","boxStyle":"Qr_boxStyle__NmtDG","MainText":"Qr_MainText__kpyHI"};